module.exports = __webpack_public_path__ + "img/brokercentre.a5d76ba.png";